import React, { useEffect, useState } from 'react';
import { getNextRoundCloseTime, formatTimeRemaining } from '../utils/transformersCompetition';

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

// Shows how much time is left before the currently open week auto-closes (every Friday 2:00 AM
// Eastern, see competitionScheduler.js) - a draining progress bar plus a short "Xd Yh left" label,
// used on the TV dashboard, Broadcast, and My Status pages so players always know the deadline
// without having to ask. Ticks every minute so a page left open (the TV dashboard especially)
// stays accurate.
function RoundCountdown({ className = '' }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(interval);
  }, []);

  const closeTime = getNextRoundCloseTime(now);
  const remainingMs = Math.max(0, closeTime.getTime() - now.getTime());
  const remainingPct = Math.min(100, Math.max(0, (remainingMs / WEEK_MS) * 100));

  return (
    <div className={`tc-round-countdown ${className}`}>
      <div className="tc-round-countdown-track">
        <div className="tc-round-countdown-fill" style={{ width: `${remainingPct}%` }} />
      </div>
      <span className="tc-round-countdown-label">{formatTimeRemaining(closeTime, now)} left</span>
    </div>
  );
}

export default RoundCountdown;
